module.exports = __webpack_public_path__ + "static/media/ResultCancerBreast.6f5b5de5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ResultCancerBreast.jpg
// module id = 508
// module chunks = 0